import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { DeleteButton, EditButton, List, useDataGrid } from "@refinedev/mui";
import React from "react";
import UserRole from "@warriortrading/warriortrading.hermes.common.feathers/enums/userRole";

export const RoleBadgesAssignmentsList = () => {
  const { dataGridProps } = useDataGrid({
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc"
        }
      ]
    },
    pagination: {
      pageSize: 10
    }
  });
  

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "role",
        headerName: "Role",
        minWidth: 170,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          return UserRole.fromValue(row.role)?.name
        },
      },
      {
        field: "badge.name",
        headerName: "BadgeName",
        minWidth: 170,
        flex: 1,
        hideable: false,
      },
      {
        field: "badge.badgeUrl",
        headerName: "BadgeUrl",
        minWidth: 170,
        flex: 1,
        hideable: false,
        renderCell: function render({row}) {
          let key: string = "badge.badgeUrl"
          return (
            <>
              <img alt="imgUrl" src={row?.[key] as any} width={45} />
            </>
          );
        },
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 160,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "createdAt",
        headerName: "CreatedAt",
        minWidth: 160,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.createdAt) {
            return new Date(row.createdAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <DeleteButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 100,
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
    </List>
  );
};
